import React from "react"
import { useFormikContext } from "formik"
import MyEditorField from "@common-utils/fields/MyEditorField"
import MyFileField from "@common-utils/fields/MyFileField"
import MyCheckboxFormField from "@common-components/fields/MyCheckboxFormField"
import { IFormValuesModel } from "./LogicAgenceVisio"
import MyLoadingOverlay from "@common-components/MyLoadingOverlay"
import clsx from "clsx" // Import clsx

interface IProps {
     isFetchingContent: boolean
     forceEditorToRefreshContent?: { value: string; random: string }
}

const EntretienAgenceFormFields: React.FC<IProps> = ({ isFetchingContent, forceEditorToRefreshContent }) => {
     const formikProps = useFormikContext<IFormValuesModel>()
     const { values, setFieldValue, errors } = formikProps

     const feelings = [
          { id: "FEELING_LIKE", icon: "fa-thumbs-up", color: "success", label: "Positif" },
          { id: "FEELING_NEUTRAL", icon: "fa-meh", color: "warning", label: "Neutre" },
          { id: "FEELING_DISLIKE", icon: "fa-thumbs-down", color: "danger", label: "Négatif" },
     ]

     return (
          <>
               {/* Notes Section */}
               <div className="mb-5">
                    <label className="col-form-label fw-bold fs-6">Notes</label>
                    <MyLoadingOverlay isActive={isFetchingContent}>
                         <MyEditorField
                              value={values.notes}
                              height={250}
                              onChange={val => setFieldValue("notes", val)}
                              placeholder={"Saisissez vos notes d'entretien..."}
                              forceEditorToRefreshContent={forceEditorToRefreshContent}
                         />
                    </MyLoadingOverlay>
                    {errors.notes && <div className="text-danger mt-1">{errors.notes}</div>}
               </div>

               {/* NEW: Feeling Section */}
               <div className="mb-10 bg-light-white p-5 rounded border border-dashed border-gray-300">
                    <label className="fw-boldest fs-6 text-gray-700 mb-4 d-block text-uppercase">Ressenti de l'entretien</label>
                    <div className="d-flex align-items-center gap-4 mb-4">
                         {feelings.map(f => (
                              <button
                                   key={f.id}
                                   type="button"
                                   className={clsx("btn btn-icon btn-xl btn-circle transition-all", values.feeling === f.id ? `btn-${f.color} shadow-sm scale-110` : "btn-light")}
                                   onClick={() => setFieldValue("feeling", values.feeling === f.id ? "" : f.id)}
                              >
                                   <i className={clsx("fas fs-2", f.icon, values.feeling === f.id ? "text-white" : `text-${f.color}`)} />
                              </button>
                         ))}
                         {values.feeling && (
                              <span className="text-gray-600 fw-bold fs-7 ms-2 animate__animated animate__fadeIn">{feelings.find(f => f.id === values.feeling)?.label}</span>
                         )}
                    </div>

                    {values.feeling && (
                         <div className="animate__animated animate__fadeIn">
                              <textarea
                                   className="form-control form-control-solid fs-7"
                                   rows={2}
                                   placeholder="Un petit commentaire sur ce ressenti ?"
                                   value={values.feelingCommentaire}
                                   onChange={e => setFieldValue("feelingCommentaire", e.target.value)}
                              />
                         </div>
                    )}
               </div>

               {/* Document Attachment */}
               <MyCheckboxFormField
                    label="Pièce jointe"
                    name="voulezVousJoindreUnDocumentToThisSuivi"
                    text="Joindre un document à ce suivi"
                    formikProps={formikProps}
                    classNameLayout={values.voulezVousJoindreUnDocumentToThisSuivi ? "mb-2" : "mb-5"}
                    classNameLabel="col-lg-4"
                    classNameField="col-lg-8"
               />

               {/* File Input */}
               {values.voulezVousJoindreUnDocumentToThisSuivi && (
                    <div className="row mb-5">
                         <div className="col-lg-8 offset-lg-4">
                              <div className="p-3 bg-light border border-dashed rounded">
                                   <MyFileField name={"document"} isInvalid={!!errors.document} onChange={val => setFieldValue("document", val)} />
                                   {errors.document && <div className="text-danger mt-1">{errors.document}</div>}
                              </div>
                         </div>
                    </div>
               )}
          </>
     )
}

export default EntretienAgenceFormFields
